module.exports = __webpack_public_path__ + "img/plan-grey.c2b94c33.svg";